import { GET_TIPOSZONASIVA_CENTRO, } from '../constants/action_types';

const initialState = [];

export default function (state = initialState, action) {

    switch (action.type) {

        case GET_TIPOSZONASIVA_CENTRO + "_SUCCESS":

            return action.payload.data;

        default:

            return state;
    };
};